export const showError = err => {
  if (!err || !err.response || !err.response.data || !err.response.data.message)
    return false;

  const { message } = err.response.data;
  console.log(message)
  switch (typeof message) {
    case 'string':
      return message;
    default: {
      return false;
    }
  }
};
